/** The onboarding questionnaire: two questions on Home, answered once, editable in Settings. */
export const onboarding = {
  stepOf: '{step} / {total}',
  continueButton: 'Continue',
  backButton: 'Back',
  skipButton: 'Skip',
  finishButton: 'Open my canvas',
  hint: 'Takes 20 seconds. You can change this later in Settings.',
  saveFailed: 'Your answers could not be saved — try again',

  roleTitle: 'What best describes you?',
  roleLede: 'It helps us build Doop for the people who use it. Pick the closest one.',
  roleDesigner: 'Designer',
  roleDesignerBlurb: 'Product, UX or visual. You think in frames.',
  roleEngineer: 'Engineer',
  roleEngineerBlurb: 'You ship the code. A design is a spec.',
  roleVibeCoder: 'Vibe coder',
  roleVibeCoderBlurb: 'You build with AI and learn as you go.',
  roleFounder: 'Founder or PM',
  roleFounderBlurb: 'You own what gets built, not the pixels.',
  roleMarketer: 'Marketer',
  roleMarketerBlurb: 'Landing pages, campaigns, creative at volume.',
  roleExploring: 'Just exploring',
  roleExploringBlurb: 'Curious, no project yet. That’s fine.',

  intentTitle: 'What are you here to make first?',
  intentLede: 'Pick the closest one. It tells us what to make Doop better at.',
  intentLanding: 'A landing page',
  intentLandingBlurb: 'Marketing site, launch page, pricing.',
  intentProductUi: 'Product UI',
  intentProductUiBlurb: 'App screens, dashboards, settings, flows.',
  intentPrototype: 'A clickable prototype',
  intentPrototypeBlurb: 'Screens wired together to test an idea.',
  intentSocial: 'Social and ad creative',
  intentSocialBlurb: 'Posts, banners, feature images, many sizes.',
  intentEmail: 'An email',
  intentEmailBlurb: 'Newsletter, lifecycle or launch mail.',
  intentUnsure: 'Not sure yet',
  intentUnsureBlurb: 'Show me around first.',

  /* Settings → Your account */
  aboutTitle: 'About you',
  aboutDescription: 'The onboarding questions: who you are and what you came to make.',
  aboutRow: 'Your answers',
  aboutUnanswered: 'Not answered yet',
  aboutUpdate: 'Update answers',
  aboutSaved: 'Saved',
} as const
